document.addEventListener('DOMContentLoaded', () => {
  initReadingProgress();
  initLightbox();
  initFAQ();
  initQuickRead();
  initGuidePage();
});

document.addEventListener("DOMContentLoaded", () => {
  let lastScrollPosition_X9k = document.documentElement.scrollTop;
  const stickyHeader_X9k = document.querySelector("sticky-header");
 
  document.addEventListener("scroll", () => {
    let currentScroll_X9k = document.documentElement.scrollTop;
 
    if (currentScroll_X9k > lastScrollPosition_X9k) {
      // scrolling down → hide header
      stickyHeader_X9k.classList.add("single-blog-header");
    } else {
      // scrolling up → show header
      stickyHeader_X9k.classList.remove("single-blog-header");
    }
 
    lastScrollPosition_X9k = currentScroll_X9k;
  });
});

// ======================================
// READING PROGRESS BAR
// ======================================
function initReadingProgress() {
  const progressEl = document.getElementById('rpb');
  if (!progressEl) return;
  window.addEventListener('scroll', () => {
    const d = document.documentElement;
    const maxScroll = d.scrollHeight - d.clientHeight;
    const progress = maxScroll > 0 ? (window.scrollY / maxScroll) * 100 : 0;
    progressEl.style.width = Math.min(progress, 100) + '%';
  });
}

// ======================================
// LIGHTBOX
// ======================================
let LB = [];
let lbCur = 0;

function initLightbox() {
  const items = document.querySelectorAll('[data-lb-idx]');
  if (!items.length) return;
  items.forEach(wrap => {
    const idx = parseInt(wrap.dataset.lbIdx, 10);
    const img = wrap.querySelector('img');
    if (!img) return;
    const capEl = wrap.closest('div')?.querySelector('.img-cap');
    LB[idx] = {
      src: img.src,
      alt: img.alt || '',
      cap: capEl ? capEl.textContent.trim() : (img.alt || '')
    };
    wrap.addEventListener('click', () => lbOpen(idx));
  });

  document.getElementById('lb-close')?.addEventListener('click', lbClose);
  document.getElementById('lb-prev')?.addEventListener('click', () => lbNav(-1));
  document.getElementById('lb-next')?.addEventListener('click', () => lbNav(1));

  document.addEventListener('keydown', (e) => {
    const lb = document.getElementById('lb');
    if (!lb || !lb.classList.contains('open')) return;
    if (e.key === 'Escape') lbClose();
    if (e.key === 'ArrowRight') lbNav(1);
    if (e.key === 'ArrowLeft') lbNav(-1);
  });
}

function lbOpen(idx) {
  const item = LB[idx];
  if (!item) return;
  lbCur = idx;
  const el  = document.getElementById('lb');
  const img = document.getElementById('lb-img');
  const cap = document.getElementById('lb-cap');
  const ctr = document.getElementById('lb-ctr');
  const prev = document.getElementById('lb-prev');
  const next = document.getElementById('lb-next');
  if (!el || !img || !cap || !ctr) return;
  img.src = item.src;
  img.alt = item.alt;
  cap.textContent = item.cap;
  ctr.textContent = `${idx + 1} / ${LB.length}`;
  if (prev) prev.style.display = idx === 0 ? 'none' : 'flex';
  if (next) next.style.display = idx === LB.length - 1 ? 'none' : 'flex';
  el.classList.add('open');
  document.body.style.overflow = 'hidden';
  el.addEventListener('click', (e) => { if (e.target === el) lbClose(); });
}

function lbClose() {
  const el = document.getElementById('lb');
  if (!el) return;
  el.classList.remove('open');
  document.body.style.overflow = '';
}

function lbNav(dir) {
  const next = lbCur + dir;
  if (next >= 0 && next < LB.length) lbOpen(next);
}

// ======================================
// FAQ — works on BOTH pages
// ======================================
function initFAQ() {
  document.addEventListener('click', function (e) {
    const question = e.target.closest('.faq-q');
    if (!question) return;

    const item = question.closest('.faq-item');
    if (!item) return;

    const answer  = item.querySelector('.faq-a');
    const isOpen  = item.classList.contains('active');

    // Close all siblings inside the nearest faq wrapper
    const wrapper = item.closest('#faq-list, .faq-container, .faq-section, section, .article-main, .guide-pg-bx');
    if (wrapper) {
      wrapper.querySelectorAll('.faq-item').forEach(faq => {
        faq.classList.remove('active');
        const ans = faq.querySelector('.faq-a');
        if (ans) ans.style.display = 'none';
      });
    }

    if (!isOpen) {
      item.classList.add('active');
      if (answer) answer.style.display = 'block';
    }
  });

  // Hide all answers on load
  document.querySelectorAll('.faq-a').forEach(ans => {
    ans.style.display = 'none';
  });
}

// ======================================
// QUICK READ (willow page — dynamic slides id="qr-0", "qr-1"...)
// ======================================
let qrCur = 0;
let qrSlideEls = [];
let QRN = 0;

function initQuickRead() {
  const dotContainer = document.getElementById('qrDots');
  if (!dotContainer) return;

  // Collect slides by id pattern qr-0, qr-1 ...
  qrSlideEls = [];
  let i = 0;
  while (true) {
    const el = document.getElementById('qr-' + i);
    if (!el) break;
    qrSlideEls.push(el);
    i++;
  }
  QRN = qrSlideEls.length;
  if (QRN === 0) return;

  // Build dots
  dotContainer.innerHTML = '';
  for (let j = 0; j < QRN; j++) {
    const dot = document.createElement('button');
    dot.className = 'qr-dot' + (j === 0 ? ' active' : '');
    dot.setAttribute('aria-label', 'Slide ' + (j + 1));
    dot.addEventListener('click', () => qrShow(j));
    dotContainer.appendChild(dot);
  }

  document.querySelectorAll('.qr-tab').forEach((tab, idx) => {
    tab.addEventListener('click', () => qrShow(idx));
  });

  document.getElementById('qrPrev')?.addEventListener('click', () => qrMove(-1));
  document.getElementById('qrNext')?.addEventListener('click', () => qrMove(1));

  // Show first slide
  qrShow(0);
}

function qrShow(idx) {
  const tabs = document.querySelectorAll('.qr-tab');
  const dots = document.querySelectorAll('.qr-dot');

  // Remove active from current
  qrSlideEls[qrCur]?.classList.remove('active');
  tabs[qrCur]?.classList.remove('active');
  dots[qrCur]?.classList.remove('active');

  qrCur = idx;

  // Add active to new
  qrSlideEls[qrCur]?.classList.add('active');
  tabs[qrCur]?.classList.add('active');
  dots[qrCur]?.classList.add('active');

  const ctr = document.getElementById('qrCtr');
  if (ctr) ctr.textContent = `${qrCur + 1} / ${QRN}`;

  const prev = document.getElementById('qrPrev');
  const next = document.getElementById('qrNext');
  if (prev) prev.disabled = qrCur === 0;
  if (next) next.disabled = qrCur === QRN - 1;

  tabs[qrCur]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
}

function qrMove(dir) {
  qrShow(Math.max(0, Math.min(QRN - 1, qrCur + dir)));
}

// ======================================
// GUIDE PAGE (bat-profiles page)
// ======================================
function initGuidePage() {
  const container = document.querySelector('.guide-pg-bx');
  if (!container) return;

  // --- Quick Read (guide page — dynamic slide count) ---
  const mainWrapper = container;
  const qrSlides       = mainWrapper.querySelectorAll('.qr-slide');
  const qrTabs         = mainWrapper.querySelectorAll('.qr-tab');
  const qrDotsContainer = mainWrapper.querySelector('#qrDots');
  const qrCounter      = mainWrapper.querySelector('#qrCounter');
  const qrPrevBtn      = mainWrapper.querySelector('#qrPrev');
  const qrNextBtn      = mainWrapper.querySelector('#qrNext');
  const QR_TOTAL       = qrSlides.length;
  let   qrCurrent      = 0;

  function initQrDots() {
    if (!qrDotsContainer) return;
    qrDotsContainer.innerHTML = '';
    qrSlides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'qr-dot' + (index === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      dot.addEventListener('click', () => showSlide(index));
      qrDotsContainer.appendChild(dot);
    });
  }

  function showSlide(index) {
    if (index < 0 || index >= QR_TOTAL) return;
    qrSlides.forEach(s => s.classList.remove('active'));
    qrTabs.forEach(t => t.classList.remove('active'));
    mainWrapper.querySelectorAll('.qr-dot').forEach(d => d.classList.remove('active'));

    qrCurrent = index;
    qrSlides[qrCurrent]?.classList.add('active');
    qrTabs[qrCurrent]?.classList.add('active');
    mainWrapper.querySelectorAll('.qr-dot')[qrCurrent]?.classList.add('active');

    if (qrCounter) qrCounter.textContent = (qrCurrent + 1) + ' / ' + QR_TOTAL;
    if (qrPrevBtn) qrPrevBtn.disabled = qrCurrent === 0;
    if (qrNextBtn) qrNextBtn.disabled = qrCurrent === QR_TOTAL - 1;

    qrTabs[qrCurrent]?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  qrTabs.forEach((tab, index) => {
    tab.addEventListener('click', (e) => { e.preventDefault(); showSlide(index); });
  });
  qrPrevBtn?.addEventListener('click', () => showSlide(Math.max(0, qrCurrent - 1)));
  qrNextBtn?.addEventListener('click', () => showSlide(Math.min(QR_TOTAL - 1, qrCurrent + 1)));

  if (QR_TOTAL > 0) { initQrDots(); showSlide(0); }

  // --- Sidebar open/close ---
  const openBtn  = container.querySelector('.blg-gltr img');
  const sidebar  = container.querySelector('.sidebar');
  const closeBtn = container.querySelector('.close-sidebar');

  if (openBtn && sidebar) {
    openBtn.addEventListener('click', () => {
      sidebar.classList.add('active');
      sidebar.style.display = 'block';
      document.body.style.overflow = 'hidden';
    });
  }
  if (closeBtn && sidebar) {
    closeBtn.addEventListener('click', () => {
      sidebar.classList.remove('active');
      document.body.style.overflow = '';
    });
  }
  if (sidebar) {
    sidebar.addEventListener('click', (e) => {
      if (e.target === sidebar) {
        sidebar.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }
}

// ======================================
// BAT FINDER QUIZ
// ======================================
document.querySelectorAll('.bt-find-quize').forEach((quiz) => {
  const quizData = {};
  let currentStep = 1;
  const totalSteps = 3;

  quiz.querySelectorAll('.quiz-opt').forEach((btn) => {
    btn.addEventListener('click', function () {
      const key = this.dataset.key;
      const val = this.dataset.val;

      this.closest('.quiz-options')
        .querySelectorAll('.quiz-opt')
        .forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
      quizData[key] = val;

      setTimeout(() => {
        if (currentStep < totalSteps) {
          quiz.querySelector('#step-' + currentStep).classList.remove('active');
          quiz.querySelector('#dot-' + currentStep).classList.remove('active');
          quiz.querySelector('#dot-' + currentStep).classList.add('done');
          currentStep++;
          quiz.querySelector('#step-' + currentStep).classList.add('active');
          quiz.querySelector('#dot-' + currentStep).classList.add('active');
        } else {
          quiz.querySelector('#step-' + currentStep).classList.remove('active');
          quiz.querySelector('#dot-' + currentStep).classList.remove('active');
          quiz.querySelector('#dot-' + currentStep).classList.add('done');
          showResult();
        }
      }, 300);
    });
  });

  function showResult() {
    const result = quiz.querySelector('#quiz-result');
    const title  = quiz.querySelector('#result-title');
    const body   = quiz.querySelector('#result-body');
    let rec = '';

    if (quizData.level === 'junior') {
      rec = 'For juniors, size is everything. Use the sizing chart in Section 4. Kashmir willow at $40–80 is perfect. Replace every 1–2 seasons. Never buy a size up "to grow into."';
    } else if (quizData.level === 'beginner') {
      rec = quizData.surface === 'tapeball'
        ? 'Start with a quality Kashmir willow bat ($50–80). Great brands: GM, SS, SG. No need for English willow yet — save your budget.'
        : 'A Grade 3–4 English willow or Kashmir willow bat at $80–$150 is ideal. Focus on correct size and weight under 2 lb 10 oz.';
    } else if (quizData.level === 'club') {
      rec = quizData.budget === 'low'
        ? 'The $100–$150 range is your sweet spot — Grade 3 English willow from SS, SG, or GM.'
        : 'Grade 2–3 English willow at $150–$250 is the best-value tier for club cricketers.';
    } else if (quizData.level === 'serious') {
      rec = 'Grade 1–2 English willow at $250–$400 is your zone. Test pickup — not scale weight.';
    }

    if (quizData.surface === 'hard' && quizData.level !== 'junior') {
      rec += ' 🇺🇸 Hard wicket tip: choose mid or mid-to-high profile and apply a toe guard before first use.';
    }

    title.textContent = 'Our Recommendation for You';
    body.textContent  = rec;
    result.classList.add('show');
  }
});

// ======================================
// TTS — Willow page (IIFE)
// ======================================
(function () {
  const ttsSup = 'speechSynthesis' in window;
  let ttsIdx = 0, ttsPlaying = false, ttsUtt = null, ttsInterval = null, elapsed = 0;

  const ttsScripts = [
    { label: 'Full Article Summary — ~4 min', text: 'Welcome to the CricketStoreOnline guide to English Willow versus Kashmir Willow, presented by Amar Shah. Both willows are legitimate — the choice is about matching the wood to your specific playing situation. English willow, Salix alba var caerulea, is grown in Essex, England. It is lighter, more responsive, and delivers superior performance for competitive leather-ball cricket. Eighty to six hundred dollars or more. Kashmir willow is grown in the Kashmir Valley of northern India. Denser, heavier bats — fifteen to twenty-five percent heavier — more affordable at thirty-five to one hundred and twenty dollars, more durable, and entirely sufficient for tape-ball cricket, beginners, and US recreational play. A well-made Kashmir bat outperforms a poorly made English bat every time. For US cricketers: hard concrete and matting surfaces accelerate wear on both willows. English willow requires a toe guard before first use. Tape ball cricket — Kashmir willow is the smarter choice, as the performance advantage of English willow disappears with softer balls. Many experienced US cricketers maintain both: English willow for league matches, Kashmir for practice and tape ball. One hundred fifty to three hundred dollars total covers every format. For personal bat advice, WhatsApp Amar Shah at six zero nine, six six six, four four six four.' },
    { label: 'English Willow — Origins & Grades', text: 'English willow, Salix alba var caerulea, is cultivated in Essex, Suffolk, and Norfolk, England. The cool, damp climate produces wood with low density and high compression strength — light enough to swing freely, strong enough to absorb eighty miles per hour impacts. J.S. Wright and Sons, founded eighteen ninety-four, produces over four hundred thousand clefts per year, supplying ninety percent of the worlds bat makers. Each tree takes fifteen to twenty years to mature. English willow is graded one through four by cosmetic quality. Grade One: three hundred fifty to six hundred dollars and above, the top ten to fifteen percent of any harvest. Grade Two: two hundred to three hundred fifty dollars, minor cosmetic marks only. Grade Three: one hundred twenty to two hundred dollars, where the price-performance ratio peaks for most US players. Grade Four: eighty to one hundred twenty dollars, functional for practice and casual play. Critical point: grade reflects cosmetic quality, not playing performance.' },
    { label: 'Kashmir Willow — Characteristics', text: 'Kashmir willow, Salix alba, is the parent species of English willow. Grown in the Kashmir Valley at fifteen hundred to two thousand meters altitude. Denser wood — bats fifteen to twenty-five percent heavier, smaller sweet spot, less ping. More durable, thirty-five to one hundred and twenty dollars. Entirely sufficient for the vast majority of cricket played in the United States. The village of Sethar in Anantnag district has over four hundred manufacturing units employing approximately eight thousand people. Top brands including SG, established nineteen thirty-one, SS, and GM produce excellent quality Kashmir willow bats. A well-made Kashmir willow bat outperforms a poorly constructed English willow bat. For tape-ball cricket, beginners, juniors, and practice, Kashmir willow is the smart choice.' },
    { label: 'US Hard Wickets — Specific Advice', text: 'Cricket in the United States creates a unique equipment context. Two factors reshape the willow decision for American players. Factor one: hard wicket surfaces. Concrete and matting surfaces are more abrasive than grass, transmit more vibration, and cause faster wear. For English willow, a toe guard applied before first use is absolutely essential. Expect two to four seasons rather than three to five on grass. Factor two: tape ball and tennis ball cricket. A significant portion of US cricket uses tape balls or tennis balls. English willows responsiveness advantage comes from leather ball compression dynamics. Softer balls dont generate the same dynamics. English willows advantage largely disappears, while Kashmir willows durability advantage remains. US Player recommendation: Leather ball on hard wicket — English willow, Grade two or three, mid-profile, with toe guard. Tape or tennis ball — Kashmir willow, fifty to one hundred dollars. Own both for maximum coverage — one hundred fifty to three hundred dollars total.' }
  ];

  function ttsStop() {
    window.speechSynthesis.cancel();
    clearInterval(ttsInterval);
    ttsPlaying = false; elapsed = 0;
    const play = document.getElementById('ttsPlay');
    if (play) play.textContent = '▶';
    const bf = document.getElementById('ttsBF'); if (bf) bf.style.width = '0%';
    const st = document.getElementById('ttsST'); if (st) st.textContent = 'Stopped';
    const tm = document.getElementById('ttsTM'); if (tm) tm.textContent = '—';
  }

  function ttsSelect(btn, idx) {
    ttsStop(); ttsIdx = idx;
    document.querySelectorAll('.tts-tb').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    document.getElementById('ttsTN').textContent = ttsScripts[idx].label;
    document.getElementById('ttsST').textContent = 'Ready · Press ▶ to listen';
    document.getElementById('ttsBF').style.width = '0%';
    document.getElementById('ttsTM').textContent = '—';
  }

  function ttsStart() {
    if (!ttsSup) return;
    window.speechSynthesis.cancel();
    clearInterval(ttsInterval);
    elapsed = 0;
    const scr = ttsScripts[ttsIdx];
    ttsUtt = new SpeechSynthesisUtterance(scr.text);
    ttsUtt.rate = parseFloat(document.getElementById('ttsSpd')?.value || 1);
    ttsUtt.lang = 'en-US';
    const estSecs = Math.round(scr.text.split(/\s+/).length / (2.5 * ttsUtt.rate));

    ttsUtt.onstart = () => {
      ttsPlaying = true;
      document.getElementById('ttsPlay').textContent = '⏸';
      document.getElementById('ttsST').textContent = 'Playing…';
      ttsInterval = setInterval(() => {
        if (!ttsPlaying || window.speechSynthesis.paused) return;
        elapsed++;
        document.getElementById('ttsBF').style.width = Math.min((elapsed / estSecs) * 100, 98) + '%';
        const r = Math.max(0, estSecs - elapsed);
        document.getElementById('ttsTM').textContent = Math.floor(r / 60) + ':' + String(r % 60).padStart(2, '0');
      }, 1000);
    };
    ttsUtt.onend = () => {
      clearInterval(ttsInterval); ttsPlaying = false;
      document.getElementById('ttsPlay').textContent = '▶';
      document.getElementById('ttsBF').style.width = '100%';
      document.getElementById('ttsST').textContent = 'Finished · Press ▶ to replay';
      document.getElementById('ttsTM').textContent = '0:00';
    };
    window.speechSynthesis.speak(ttsUtt);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const playBtn = document.getElementById('ttsPlay');
    if (!playBtn) return;

    document.querySelectorAll('.tts-tb').forEach((btn, idx) => {
      btn.addEventListener('click', () => ttsSelect(btn, idx));
    });

    playBtn.addEventListener('click', function () {
      if (!ttsSup) return;
      if (ttsPlaying) {
        window.speechSynthesis.pause(); ttsPlaying = false;
        this.textContent = '▶';
        document.getElementById('ttsST').textContent = 'Paused · Press ▶ to resume';
      } else if (window.speechSynthesis.paused) {
        window.speechSynthesis.resume(); ttsPlaying = true;
        this.textContent = '⏸';
        document.getElementById('ttsST').textContent = 'Playing…';
      } else {
        ttsStart();
      }
    });
  });
})();

// ======================================
// TTS — Guide page (blog-single-guides)
// ======================================
document.addEventListener('DOMContentLoaded', function () {
  const mainWrapper = document.querySelector('.blog-single-guides');
  if (!mainWrapper) return;

  const ttsScripts = [
    {
      label: 'Full Guide Summary — ~5 min',
      text: `Welcome to the Cricket Bat Guide 2026 by CricketStoreOnline, presented by Amar Shah. This is the complete guide to choosing, preparing, and maintaining the right cricket bat. The number one rule: choosing a cricket bat is about matching four variables to how and where you play. Wood type, weight, profile, and size. Get these right, and you will feel the difference from your very first innings. On willow: English willow, grown in Essex England, is lighter and more responsive. It delivers superior performance for competitive leather-ball cricket, and costs between eighty and six hundred dollars. Kashmir willow is denser, more affordable at forty to one hundred and twenty dollars, and ideal for beginners and tape-ball play. Neither is inferior — a well-made Kashmir bat beats a poorly made English bat every single time. Many experienced US cricketers keep one of each. On weight: the biggest myth in cricket is that a heavier bat means more power. Physics disagrees. Kinetic energy scales with velocity squared. Doubling bat speed quadruples power. Doubling weight only doubles it. Bradman — career Test average ninety nine point nine four — used one of the lightest bats in professional cricket. Most adults play best between two pounds seven ounces and two pounds ten ounces. Always test pickup, not just scale weight. Hold the bat at arm length for fifteen seconds. If your wrist trembles, it is too heavy. On profiles: the blade cross-section determines where your sweet spot sits. Low profiles suit front-foot play on slow pitches. Mid profiles are versatile — sixty to seventy percent of all bats sold worldwide. High profiles suit back-foot shots and bouncy wickets. For US players on concrete and matting, mid or mid-to-high profiles are essential. On US hard wickets: concrete and matting create higher bounce, more vibration, and faster toe wear. Three changes from a typical UK guide: choose mid to high profile, invest in a quality handle with rubber inserts, and apply a toe guard before first use. On preparation: every new English willow bat must be knocked in over seven to ten days before match use. Oil the face, edges, and toe with raw linseed. Then knock progressively with a mallet. For brand guidance: Gray-Nicolls excels at two hundred and fifty dollars and above. Gunn and Moore offers genuine quality at every price point. Kookaburra provides the lightest pickup. SS and SG offer the best value in Grade two and three English willow. For personal bat advice, WhatsApp Amar Shah at six zero nine, six six six, four four six four. Thank you for listening.`
    },
    { label: 'Willow Types — ~1 min', text: `English Willow versus Kashmir Willow. English willow, Salix alba caerulea, is grown in Essex, Suffolk, and Norfolk in England. The cool damp climate creates a unique cellular structure — low density with high compression strength. This makes it light enough to swing freely and strong enough to absorb repeated leather-ball impact. Prices run from eighty to over six hundred dollars, and bats last three to five seasons with care. Kashmir willow grows in the Kashmir Valley of India at higher altitude in drier conditions, producing denser, heavier wood. It is more affordable at forty to one hundred and twenty dollars, more durable, and entirely sufficient for beginners, casual players, and tape-ball cricket. The key insight: Kashmir willow is not inferior. Quality of construction matters as much as raw material. Many experienced US cricketers keep both — English willow for competitive matches, Kashmir willow for practice and tape ball.` },
    { label: 'Weight Science — ~1 min', text: `The Weight Myth. The most common misconception in cricket equipment: heavier bat equals more power. The physics are clear. Kinetic energy equals one half mass times velocity squared. Velocity is squared — so doubling bat speed quadruples energy transfer. Doubling weight only doubles it. Australian researchers confirmed that lighter bats are swung up to ten percent faster, producing exit speeds approximately seven and a half percent higher. Bradman used a near-featherlight bat and compiled the highest Test average in history: ninety nine point nine four. Most adults play best at two pounds seven ounces to two pounds ten ounces. Kohli uses approximately two pounds nine ounces. Ponting used two pounds seven ounces. Chris Gayle uses three pounds for pure T20 power. Always test pickup — hold the bat at arm length for fifteen seconds. If your wrist trembles or the tip drops, it is too heavy regardless of what the scale says. When in doubt, go lighter.` },
    { label: 'US Hard Wickets — ~1 min', text: `What every American cricketer needs to know about hard wickets. The vast majority of cricket bat content online is written for grass wickets. In the United States, most cricket is played on concrete strips with artificial turf matting, compressed earth, or indoor synthetic floors. These surfaces create three critical differences. First: higher, more consistent bounce. Hard wickets produce steeper bounce than grass. The ball arrives in the mid to upper zone of the blade more frequently. This means mid or mid to high profiles outperform low profiles. Second: greater shock transmission. Hard surfaces transfer more vibration through the ball into the bat. A quality cane handle with rubber inserts reduces hand sting significantly. Third: accelerated toe and edge wear. Hard surfaces are abrasive. Without a toe guard, a premium bat can sustain serious toe damage in a single match. Apply a toe guard before first use — this is not optional on US wickets. For tape ball and tennis ball cricket, Kashmir willow at sixty to one hundred dollars is the clear choice.` },
    { label: 'Bat Prep Guide — ~1 min', text: `How to prepare a new cricket bat. This is not optional. Using an English willow bat without preparation risks cracking, splitting, or permanent damage on the very first delivery. The process takes seven to ten days. Days one to four: apply thin coats of raw linseed oil to the face, edges, and toe. Do not oil the back or the splice. Allow twenty four hours absorption between two to three applications. Days four to six: knock with a bat mallet at fifty to sixty percent force. Cover the entire face and edges. Thirty to forty five minutes per session. Days six to eight: increase to seventy to eighty percent force. The face should feel harder and sound sharper. Day eight to nine: the ball bounce test. Drop an old leather ball from two feet. A brisk rebound means ready. A dull thud means continue knocking. Days nine to ten: two to three net sessions with practice balls before first match use. Before any of this: apply a toe guard. This five to ten dollar investment can add years to your bats life — essential on US hard wickets. CricketStoreOnline offers professional bat preparation at stores in New Jersey and Georgia. WhatsApp Amar at six zero nine, six six six, four four six four.` }
  ];

  let ttsIdx = 0, ttsUtterance = null, ttsPlaying = false, progressInterval = null;
  const ttsSupported = 'speechSynthesis' in window;

  const playBtn      = mainWrapper.querySelector('#playBtn');
  const trackLabel   = mainWrapper.querySelector('#trackLabel');
  const progressFill = mainWrapper.querySelector('#progressFill');
  const podcastTime  = mainWrapper.querySelector('#podcastTime');
  const podcastStatus = mainWrapper.querySelector('#podcastStatus');
  const speedSelect  = mainWrapper.querySelector('#speedSelect');
  const trackBtns    = mainWrapper.querySelectorAll('.track-btn');

  if (!playBtn) return;

  if (!ttsSupported) {
    if (podcastStatus) podcastStatus.textContent = '⚠️ Your browser does not support text-to-speech.';
    playBtn.disabled = true;
    return;
  }

  function stopTTS() {
    window.speechSynthesis.cancel();
    clearInterval(progressInterval);
    ttsPlaying = false;
    playBtn.textContent = '▶';
    if (progressFill) progressFill.style.width = '0%';
    if (podcastStatus) podcastStatus.textContent = 'Stopped';
  }

  function startTTS() {
    window.speechSynthesis.cancel();
    const script = ttsScripts[ttsIdx];
    if (!script) return;
    ttsUtterance = new SpeechSynthesisUtterance(script.text);
    ttsUtterance.rate  = parseFloat(speedSelect?.value || 1);
    ttsUtterance.pitch = 1;
    ttsUtterance.lang  = 'en-US';
    const estSecs = Math.max(1, Math.round(script.text.split(/\s+/).length / (2.5 * ttsUtterance.rate)));
    let elapsed = 0;

    ttsUtterance.onstart = function () {
      ttsPlaying = true;
      playBtn.textContent = '⏸';
      if (podcastStatus) podcastStatus.textContent = 'Playing…';
      progressInterval = setInterval(function () {
        if (window.speechSynthesis.paused) return;
        elapsed++;
        const pct = Math.min((elapsed / estSecs) * 100, 100);
        if (progressFill) progressFill.style.width = pct + '%';
        const rem = Math.max(0, estSecs - elapsed);
        if (podcastTime) podcastTime.textContent = Math.floor(rem / 60) + ':' + String(rem % 60).padStart(2, '0');
      }, 1000);
    };
    ttsUtterance.onend = function () {
      clearInterval(progressInterval); ttsPlaying = false;
      playBtn.textContent = '▶';
      if (progressFill) progressFill.style.width = '100%';
      if (podcastStatus) podcastStatus.textContent = 'Finished · Press ▶ to replay';
      if (podcastTime) podcastTime.textContent = '0:00';
    };
    ttsUtterance.onerror = function () {
      clearInterval(progressInterval); ttsPlaying = false;
      playBtn.textContent = '▶';
      if (podcastStatus) podcastStatus.textContent = 'Error occurred while playing audio';
    };
    window.speechSynthesis.speak(ttsUtterance);
  }

  playBtn.addEventListener('click', function () {
    if (ttsPlaying) {
      window.speechSynthesis.pause(); ttsPlaying = false;
      this.textContent = '▶';
      if (podcastStatus) podcastStatus.textContent = 'Paused · Press ▶ to resume';
    } else if (window.speechSynthesis.paused) {
      window.speechSynthesis.resume(); ttsPlaying = true;
      this.textContent = '⏸';
      if (podcastStatus) podcastStatus.textContent = 'Playing…';
    } else {
      startTTS();
    }
  });

  speedSelect?.addEventListener('change', function () {
    if (ttsPlaying) { stopTTS(); setTimeout(startTTS, 100); }
  });

  trackBtns.forEach(function (btn, index) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      stopTTS();
      ttsIdx = index;
      trackBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      if (trackLabel && ttsScripts[index]) trackLabel.textContent = ttsScripts[index].label;
      if (podcastStatus) podcastStatus.textContent = 'Ready · Press ▶ to listen';
      if (progressFill) progressFill.style.width = '0%';
      if (podcastTime) podcastTime.textContent = '—';
    });
  });

  // Smooth scroll
  mainWrapper.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });
});